import React from "react";
import { FaFacebook } from "react-icons/fa";

export const Facebookicon = ({ className }) => {
  return (
    <FaFacebook
      alt="whatsapp"
      className={className}
      // style={{
      //   fontSize: "65px",
      //   position: "fixed",
      //   right: "6.5%",
      //   bottom: "15%",
      //   zIndex: "11",
      // }}
    />
  );
};
